import { makeStyles } from '@material-ui/core/styles'
import AccordionBase from '../../2compounds/AccordionBase'
import { useContext, useEffect, useState } from 'react'
import { GlobalContext } from '../../../services/context/DataContext'
import SetToDefaultButton from '../../1elements/Buttons/IconButtons/SetToDefaultButton'
// import ReplayIcon from '@mui/icons-material/Replay';

const ConfigAccordionBase = ({ children, label, className, onEditMode, setToDefaultHandler }) => {
  const { activeTabData } = useContext(GlobalContext)
  const [activeTab] = activeTabData
  const classes = useStyles()
  const [isOpen, setIsOpen] = useState(true)

  useEffect(() => {
    switch (activeTab) {
      case '13': // '13' is the nodeId for Colors
        if (label === 'Colors') setIsOpen(true)
        break
      case '14': // '14' is the nodeId for Font Style
        if (label === 'Font Style') setIsOpen(true)
        break
      case '15': // '15' is the nodeId for Icons
        if (label === 'Icons') setIsOpen(true)
        break
      case '19': // '19' is the nodeId for Map Centralization
        if (label === 'Map Centralization') setIsOpen(true)
        break
      case '20': // '20' is the nodeId for Marker
        if (label === 'Marker') setIsOpen(true)
        break
      default:
        setIsOpen(true)
    }
    const selectedColor = localStorage.getItem('tempColorSelect')
    if (selectedColor) {
      setIsOpen(true)
    }

    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [activeTab])

  useEffect(() => {
    const onPreviewMode = localStorage.getItem('previewMode')
    if (onPreviewMode) {
      setIsOpen(true)
    }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [])

  return (
    <AccordionBase label={label} className={classes.root} isOpen={isOpen} setIsOpen={setIsOpen}>
      {onEditMode && setToDefaultHandler && (<SetToDefaultButton className={classes.defaultButton} onClick={setToDefaultHandler} />)}
      <div className={`${classes.innerDiv} ${className}`}>
        {children}
      </div>
    </AccordionBase>
  )
}

export default ConfigAccordionBase

const useStyles = makeStyles({
  root: {
  },
  innerDiv: {
    padding: '30px 40px'
  },
  defaultButton: {
    position: 'absolute',
    top: 0,
    right: 0
  }
})
